import { KTSVG } from "_metronic/helpers"
import { CSSProperties, FC } from "react"

type Props = {
    displayButton?: CSSProperties,
    incidences?: number,
    coincidences?: number
}

const AlertComponent: FC<Props> = ({ displayButton, incidences, coincidences }) => {
    return (
        <>
        {incidences !== 0 ?
            <div className="alert alert-dismissible bg-light-danger d-flex flex-column flex-sm-row p-5 mb-10" style={{ alignItems: "center" }}>
                <span className="svg-icon svg-icon-2hx svg-icon-primary me-4 mb-5 mb-sm-0">
                    <KTSVG
                        path="/media/icons/duotune/general/gen044.svg"
                        className="svg-icon-1 fs-7"
                    />
                </span>
                <div className="d-flex flex-column text-primary pe-0 pe-sm-10 ">
                    <h5 className="text-danger m-0">Tiene {incidences} errores de incidencias y {coincidences} de coincidencias</h5>
                </div>

                <button type="button" className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto" style={{ display: 'none' }} data-bs-dismiss="alert">
                    <span className="svg-icon svg-icon-1 svg-icon-primary">
                        <KTSVG
                            path="/media/icons/duotune/layouts/lay001.svg"
                            className="svg-icon-1 fs-7" />
                    </span>
                </button>
            </div>
        : ""}

        </>
    )
}

export { AlertComponent }